"use strict";

exports.__esModule = true;

var _Router = require("react-router/Router");

var _Router2 = _interopRequireDefault(_Router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Router2.default; // Written in this round about way for babel-transform-imports


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/~/react-router-dom/Router.js
// module id = 84
// module chunks = 168707334958949